<template>
<div>
	<Loader :show="loading"></Loader>

	<div class="fullscreen" >
		
		<div class="head head-with-brand big">
			<div class="container">
				<div class="btn icon icon-close invert" @click="cancelControl"></div>
				<small>CHASSIS</small>
				<h1>{{control.car.chassis_number}}</h1>
				<h2>{{control.car.brand.title}} {{control.car.model}}</h2>
				<div class="brand" v-if="control.car.brand.logo" :style="{backgroundImage:`url(${API_URL+control.car.brand.logo.urlThumb})`}"></div>
			</div>
		</div>
		
		<div class="content">
			<div class="container">
				<div class="mt-2 text-center">
					<h1 class="mt-3 mb-2">Revise el vehículo en busca de daños o faltantes de documentación</h1>
					<img :src="require('@/assets/icons/icon-checklist.png')">
				</div>

				<div class="mt-4" v-if="control.damages && control.damages.length>0">
					<h5 >DAÑOS</h5>
					<div class="list-group box-shadow  mt-2">

						<div class="item" v-for="(damage, index) in control.damages" :key="index" >
							<div class="images" 
								:style="{backgroundImage: `url('${API_URL+damage.images[0].url}')` }">
							</div>
							<div class="info">
								<p>{{damage.type}}</p>
								<h3>{{damage.description}}</h3>
							</div>
							<div class="btn btn-circle btn-light mr-2" @click="updateDamage(damage)"><i class="icon icon-edit"></i></div>
							<div class="btn btn-circle btn-light mr-2" @click="deleteDamage(index)"><i class="icon icon-close"></i></div>
						</div>
						<!-- <div class="alert alert-light text-center" v-if="control.newDamages.length<=0">No hay daños registrados</div> -->
					</div>
				</div>
				
				<div class="mt-4" v-if="control.missings && control.missings.length>0">
					<h5 >FALTANTES</h5>
					<div class="list-group box-shadow mt-2">
						<div class="item pt-1 pb-1" v-for="(missing, index) in control.missings" :key="index" >
							<div class="info">
								<h3>{{missing.description}}</h3>
							</div>
							<div class="btn btn-circle btn-light mr-2" @click="updateMissing(missing)"><i class="icon icon-edit"></i></div>
							<div class="btn btn-circle btn-light mr-2" @click="deleteMissing(index)"><i class="icon icon-close"></i></div>
						</div>
					</div>
				</div>

				<div class="action-buttons mt-4 mt-4 pb-4">
					<div class="btn btn-warning" @click="createDamage()">Crear Daño</div>
					<div class="btn btn-warning" @click="createMissing()">Crear faltante</div>
				</div>
			</div>
		</div>

		<div class="footer">
			<div class="container">
				<div class="btn btn-block btn-primary" @click="nextStep()">
					Continuar
				</div>
			</div>
		</div>

		<DamageForm ref="damageForm"></DamageForm>
		<MissingForm ref="missingForm"></MissingForm>
	</div>
	
	<DeliveryForm 
		v-if="control.step=='DeliveryForm'"
		ref="DeliveryForm"
		title="Ingrese los datos de quien retira el vehículo"
		type="success"
		@done="nextStep"
		@cancel="cancelControl"
	></DeliveryForm>

	<ControlSuccess 
		v-if="control.step=='ControlSuccess'"
		:control="controlCreated"
	></ControlSuccess>

</div>
</template>


<script>
import gql from 'graphql-tag'
import { mapState, mapMutations } from 'vuex'
import Loader from '@/components/Loader'

import DamageForm from '@/views/controls/DamageForm'
import MissingForm from '@/views/controls/MissingForm'

import DeliveryForm from '@/views/controls/DeliveryForm'
import ControlSuccess from '@/views/controls/ControlSuccess'


export default {
	name: 'CarDelivery',
	components: {
		Loader,
		DamageForm,
		MissingForm,
		DeliveryForm,
		ControlSuccess
	},
	data(){
		return{
			API_URL: process.env.VUE_APP_API_URL,
			loading: false,
			controlCreated: null,
		}
	},
	computed: {
		...mapState(['control'])
	},
	methods:{
		...mapMutations(['saveControl','deleteControl']),
		cancelControl(){
			this.$router.push(`/control/${this.control.car.id}`)
			this.deleteControl()
		},
		createDamage(){
			this.$refs.damageForm.open()
		},
		updateDamage(damage){
			this.$refs.damageForm.update(damage)
		},
		deleteDamage(index){
			this.control.damages.splice(index,1)
			this.saveControl(this.control)
		},
		createMissing(){
			this.$refs.missingForm.open()
		},
		updateMissing(missing){
			this.$refs.missingForm.update(missing)
		},
		deleteMissing(index){
			this.control.missings.splice(index,1)
			this.saveControl(this.control)
		},
		nextStep () {
			if( this.control.step == 'main' ) {
				this.control.step = 'DeliveryForm'
				return
			}
			if( this.control.step == 'DeliveryForm' ) {
				this.finishControl()
				return
			}
		},
		finishControl(){
			if(!this.loading ) {
				this.$dialog
				.confirm('Confirmar entrega',{
					cancelText: 'Cancelar',
					okText: 'Confirmar'
				})
				.then(() => {
					this.finishControlOK()
				})
			}
		},
		finishControlOK(){
			this.loading = true
			let dataInput = {
				car_id 			: this.control.car.id,
				damages 		: [],
				missings 		: [],
				delivered_by_mat		: this.control.delivered_by_mat,
				delivered_by_driver_name: this.control.delivered_by_driver_name,
				delivered_by_driver_signature: this.control.delivered_by_driver_signature,
			}
			if( this.control.damages.length >0 ){
				this.control.damages.forEach( damage => {
					let imagesIds = damage.images.map(a => a.id)
					dataInput.damages.push({
						images 		: imagesIds,
						description : damage.description,
						position : damage.position,
						type : damage.type,
						side : damage.side,
					})
				})
			}
			if( this.control.missings.length >0 ){
				this.control.missings.forEach( missing => {
					dataInput.missings.push({
						description : missing.description,
					})
				})
			}
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:ControlDeliveryInput! ){
					controlDelivery( data: $data) {
						id
						user{
							name
						}
						car{
							id
							category{
								draw
							}
						}
						type
						typeText
						comments
						files{
							id
							url
							urlThumb
						}
						damages{
							side
							images{
								urlThumb
							}
							position{
								top
								left
							}
							type
							typeText
							description
							status
						}
						missings{
							description
						}
						truck_mat
						truck_driver_name
						truck_driver_signature
						created_at
					}
				}`,
				variables: {
					data: dataInput
				}
			})
			.then((data) => {
				this.controlCreated = data.data.controlDelivery
				this.loading = false
				this.control.step = 'ControlSuccess'
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.loading = false
			})
		}
	}
	
}
</script>

<style scoped lang="scss">
.action-buttons{
	display:flex;
	justify-content: center;
	max-width: 480px;
    margin: auto;
}
.action-buttons .btn{
	flex-grow: 1;
	margin:0px 2px;
}



</style>
